<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>
<!-- <ubs-marketing-calendar></ubs-marketing-calendar> -->
<!-- <ubs-calendar-container></ubs-calendar-container> -->
